import { Line } from "react-chartjs-2";
import { Box } from "@mui/material";
import React, { useState, useEffect } from "react";
import {
  Chart as ChartJs,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler,
} from "chart.js";
import Colors from "../../../assets/Variables/ColorsVariables.js";
import * as TextVariables from "../../../assets/Variables/TextVariables.js";
import { useDynamicStyles } from "./Styles.js";

ChartJs.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  Filler
);

function LinesChart({ dataChart, yLabel = "No defined" , signalCurrency }) {
  const styles = useDynamicStyles();
  const [data, setData] = useState({
    labels: ["01"],
    datasets: [
      {
        label: "Profit",
        data: [23],
        borderColor: "rgba(255, 0, 0, 0.6)",
        backgroundColor: "rgba(233, 93, 6, 0.2)",
        yAxisID: "y-axis-volumen",
        tension: 0.4,
      },
    ],
  });

  useEffect(() => {
    if (dataChart) {
      setData(dataChart);
    }
  }, [dataChart]);

const OptionsLine = {
  responsive: true,
  maintainAspectRatio: false,
  interaction: {
    mode: "index",
    intersect: false,
  },
  stacked: false,
  plugins: {
    legend: {
      display: false, // Oculta la leyenda predeterminada
    },
    title: {
      display: true,
    },
  },
  scales: {
    x: {
      beginAtZero: false,
      min: 1, 
      offset: false,//Necesario para quitar margenes, una vez el conteo es desde el numero 1
      display: true,
      title: {
        display: false,
        text: "Meses",
      },
      grid: {
        display: false,
      },
      ticks: {
        stepSize: 1,
        font: {
          family: TextVariables.Overline.fontFamily,
          size: TextVariables.Overline.size,
          weight: TextVariables.Overline.weight,
        },
        color: Colors.Secondary_600,
      },
    },
    "y-axis-volumen": {
      type: "linear",
      display: true,
      position: "left",
      title: {
        display: true,
        text: yLabel,
        font: {
          family: TextVariables.Overline.fontFamily,
          size: TextVariables.Overline.size,
          weight: TextVariables.Overline.weight,
        },
      },
      min: 1, // 🔹 Si también quieres que el eje Y empiece en 1
      ticks: {
        callback: function (value) {
          return Number.isInteger(value) ? value : null;
        },
        font: {
          family: TextVariables.Overline.fontFamily,
          size: TextVariables.Overline.size,
          weight: TextVariables.Overline.weight,
        },
        color: Colors.Secondary_600,
      },
    },
  },
};
  return (
    <Box sx={{ display: "flex", width: "100%", height: "100%" }}>
      <Line data={data} options={OptionsLine} />
    </Box>
  );
}

export default LinesChart;
